import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';
import { getTopMargin } from '../../components/BlockMenu/BlockMenu';

export const DragHandle = styled.div<{ type: string | undefined }>`
  cursor: move;
  padding-top: ${(props) => getTopMargin(props.type)}px;
  padding-left: 2px;

  svg {
    height: 16px;
  }

  svg {
    fill: ${theme.color.designSystem.blackOpacity60};
  }

  &:hover:before {
    content: '';
    position: absolute;
    top: calc(${(props) => getTopMargin(props.type)}px - 4px);
    left: 6px;
    width: 16px;
    height: 24px;
    border-radius: ${theme.borderRadius.medium};
    background-color: ${theme.color.designSystem.background.lightPurple.hover};
  }

  &:hover {
    svg path + path {
      fill: ${theme.color.designSystem.purple70};
    }
  }
`;

export const DragContent = styled.div`
  width: 100%;
`;

export const DragContainer = styled.div`
  display: flex;
  position: relative;
`;
